export class AssetClass {
    static options() {
        return [
            {
                value: 'MHCR',
                text: 'Manhole and Chamber'
            },
            {
                value: 'CPIT',
                text: 'Catchpit'
            },
            {
                value: 'SOAK',
                text: 'Soakage System'
            },
            {
                value: 'ILOL',
                text: 'Inlet and Outlet'
            },
            {
                value: 'PIPE',
                text: 'Pipe'
            },
            {
                value: 'PUMP',
                text: 'Pumpstation'
            },
            {
                value: 'WRTD',
                text: 'Water Treatment Device'
            },
            {
                value: 'WRTF',
                text: 'Water Treatment Facility'
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./src/helpers/asset-class-options.js